export default "__VITE_ASSET__CJFikmpL__"